export default {
  data() {
    return {
      editingInvoiceId: null,
      originalRows: null,
      isSaving: false,
      editingMainInvoiceId: null,
      originalMainData: null,
      changedMainItems: [],
      isSavingMain: false,
      deletedRowIds: [],
      newRowCounter: 0
    };
  },
  computed: {
    hasMainChanges() {
      return this.changedMainItems.length > 0;
    }
  },
  methods: {
    isEditingMain(invoiceId) {
      return this.editingMainInvoiceId === invoiceId;
    },
    isEditing(invoiceId) {
      return this.editingInvoiceId === invoiceId;
    },
    startMainEdit(item) {
      this.editingMainInvoiceId = item.id;
      this.originalMainData = JSON.parse(JSON.stringify(item));
      this.$set(item, "dateMenu", false);
      this.$set(item, "deadlineMenu", false);
    },
    cancelMainEdit(item) {
      if (this.originalMainData) {
        const index = this.items.findIndex(i => i.id === item.id);
        if (index !== -1) {
          this.$set(this.items, index, this.originalMainData);
        }
      }
      this.editingMainInvoiceId = null;
      this.originalMainData = null;
      const changedIndex = this.changedMainItems.indexOf(item.id);
      if (changedIndex > -1) {
        this.changedMainItems.splice(changedIndex, 1);
      }
    },
    markMainAsChanged(item) {
      if (!this.changedMainItems.includes(item.id)) {
        this.changedMainItems.push(item.id);
      }
    },
    startEdit(item) {
      this.editingInvoiceId = item.id;
      this.originalRows = JSON.parse(JSON.stringify(item.rows));
      this.deletedRowIds = [];

      // This is for the dropdowns to show current values when entering edit mode
      if (item.rows) {
        item.rows.forEach(row => {
          if (row.accountingValue) {
            if (!row.aiInvoiceAccountingValueId) {
              row.aiInvoiceAccountingValueId = row.accountingValue.id;
            }
            if (
              !row.aiInvoiceAccountingValueTypeId &&
              row.accountingValue.aiInvoiceAccountingValueTypeId
            ) {
              row.aiInvoiceAccountingValueTypeId =
                row.accountingValue.aiInvoiceAccountingValueTypeId;
            }
            if (
              !row.aiInvoiceAccountingValueTypeId &&
              row.accountingValue.accountingValueType
            ) {
              row.aiInvoiceAccountingValueTypeId =
                row.accountingValue.accountingValueType.id;
            }
          }
          if (row.accountingValueType && !row.aiInvoiceAccountingValueTypeId) {
            row.aiInvoiceAccountingValueTypeId = row.accountingValueType.id;
          }
        });
      }
    },
    cancelEdit(item) {
      if (this.originalRows) {
        item.rows = this.originalRows;
      }
      this.editingInvoiceId = null;
      this.originalRows = null;
      this.deletedRowIds = [];
    },
    addRow(item) {
      if (!item.rows) {
        this.$set(item, "rows", []);
      }
      item.rows.push({
        id: null,
        tempId: `temp-${this.newRowCounter++}`,
        itemName: "",
        aiInvoiceAccountingValueTypeId: null,
        aiInvoiceAccountingValueId: null,
        itemQuantity: 0,
        itemPrice: 0,
        itemDiscountPercentage: 0,
        itemTotalPrice: 0,
        itemRowNumber: item.rows.length + 1
      });
    },
    deleteRow(item, index) {
      const row = item.rows[index];
      if (row.id) {
        this.deletedRowIds.push(row.id);
      }
      item.rows.splice(index, 1);

      item.rows.forEach((row, idx) => {
        row.itemRowNumber = idx + 1;
      });
    },
    updateTotalPrice(row) {
      const quantity = parseFloat(row.itemQuantity) || 0;
      const price = parseFloat(row.itemPrice) || 0;
      const discount = parseFloat(row.itemDiscountPercentage) || 0;

      const subtotal = quantity * price;
      const discountAmount = (subtotal * discount) / 100;
      row.itemTotalPrice = (subtotal - discountAmount).toFixed(2);
    },
    updateRowField(item, index, field, value) {
      const row = item.rows[index];
      row[field] = value;

      if (field === "aiInvoiceAccountingValueTypeId") {
        row.aiInvoiceAccountingValueId = null;
      }

      if (
        field === "itemQuantity" ||
        field === "itemPrice" ||
        field === "itemDiscountPercentage"
      ) {
        this.updateTotalPrice(row);
      }
    },
    updateMainField(item, field, value) {
      item[field] = value;
      this.markMainAsChanged(item);
    }
  }
};
